import { makeStyles } from "@/utils"

const useStyles = makeStyles((theme) => ({
	footer: {
		gap: theme.spacing(3),
		paddingBottom: theme.spacing(5)
	}
}))

export default useStyles
